export default {
  label: {
    display: 'block',
    fontSize: '16px',
    lineHeight: 1,
    padding: '5px 0 10px 0',
  },
  select: {
    width: '800px',
    borderColor: 'transparent',
    display: 'block',
    resize: 'none',
    overflow: 'auto',
  },
  option: {
    border: '2px solid #FFEB3B',
    display: 'inline-block',
    float: 'left',
    margin: '3px',
    padding: '7px 10px',
    borderRadius: '4px',
    width: '50px',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
}
